const BAD_STORED_VALUES = new Set(["", "undefined", "null", "false"]);

function normalized(value) {
  return String(value ?? "").trim();
}

export function cleanStoredUrl(value) {
  const text = normalized(value);
  if (BAD_STORED_VALUES.has(text.toLowerCase())) return "";
  return text;
}

function appendNext(url, next) {
  const cleanUrl = cleanStoredUrl(url);
  const cleanNext = cleanStoredUrl(next);

  if (!cleanUrl || !cleanNext) return cleanUrl;

  try {
    const target = new URL(cleanUrl, window.location.origin);
    target.searchParams.set("next", cleanNext);
    return target.toString();
  } catch (_error) {
    return cleanUrl;
  }
}

export function storeOptionalUrl(key, value) {
  const clean = cleanStoredUrl(value);

  if (clean) {
    localStorage.setItem(key, clean);
    return clean;
  }

  localStorage.removeItem(key);
  return "";
}

export function loginFallbackUrl() {
  if (process.env.REACT_APP_LOGIN_URL) return process.env.REACT_APP_LOGIN_URL;
  if (process.env.REACT_APP_NODE_ENV === "production") return "https://auth.feradel.com";
  return "/";
}

export function loginRedirectUrl(next = "") {
  const stored = cleanStoredUrl(localStorage.getItem("loginUrl"));

  if (stored) return appendNext(stored, next);

  localStorage.removeItem("loginUrl");
  return appendNext(loginFallbackUrl(), next);
}

export function sameOriginPath(value) {
  const clean = cleanStoredUrl(value);
  if (!clean) return "";

  try {
    const url = new URL(clean, window.location.origin);
    const path = `${url.pathname}${url.search}${url.hash}`;
    if (url.origin === window.location.origin) return path;
    if (url.pathname === "/dashboard" || url.pathname.startsWith("/dashboard/")) return path;
    return "";
  } catch (_error) {
    return "";
  }
}
